import cfg from './config.json';
import { APIConfig } from '../../../';

const Config = new APIConfig(cfg).cfg;

export default Config;
